/* ============================================================================
   LISTICLE HOTEL · window.__listicleHotel namespace
   Testimonials carousel: transform-based (track translates by -100% * idx).
   Swipe gestures supported for touch devices.
   Sticky bar uses raf-throttled scroll handler.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__listicleHotel) return;
  window.__listicleHotel = { initialized: false };

  var SCOPE = '.shopify-section.section-listicle-hotel';
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function initTestimonials(section) {
    var car = section.querySelector('[data-testimonials]');
    if (!car) return;
    var track    = car.querySelector('[data-testimonials-track]');
    var dotsWrap = car.querySelector('[data-testimonials-dots]');
    if (!track) return;
    var slides = $$('[data-testimonials-slide]', track);
    if (slides.length === 0) return;

    var idx = 0;
    var total = slides.length;
    var autoplay = car.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(car.getAttribute('data-autoplay-ms') || '6500', 10);
    var timer = null;

    function applyTransform() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    }

    function syncDotsTo(i) {
      if (!dotsWrap) return;
      $$('.lh__testimonials-dot', dotsWrap).forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
      });
    }

    function setIndex(i) {
      idx = ((i % total) + total) % total;
      applyTransform();
      syncDotsTo(idx);
    }

    function go(d) {
      setIndex(idx + d);
      restartAutoplay();
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(function () { setIndex(idx + 1); }, autoplayMs);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'lh__testimonials-dot' + (i === idx ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        (function (k) {
          on(d, 'click', function () { setIndex(k); restartAutoplay(); });
        })(i);
        dotsWrap.appendChild(d);
      }
    }

    on(car.querySelector('[data-testimonials-dir="prev"]'), 'click', function () { go(-1); });
    on(car.querySelector('[data-testimonials-dir="next"]'), 'click', function () { go(1); });

    on(car, 'mouseenter', stopAutoplay);
    on(car, 'mouseleave', startAutoplay);

    var touchStartX = 0;
    var touchStartY = 0;
    var touching = false;
    var SWIPE_THRESHOLD = 40;

    on(track, 'touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touching = true;
      stopAutoplay();
    }, { passive: true });

    on(track, 'touchend', function (e) {
      if (!touching) return;
      touching = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? 1 : -1);
      } else {
        startAutoplay();
      }
    }, { passive: true });

    on(track, 'touchcancel', function () {
      touching = false;
      startAutoplay();
    });

    applyTransform();
    syncDotsTo(idx);
    startAutoplay();
  }

  function initStickyBar(section) {
    var bar = section.querySelector('[data-sticky]');
    if (!bar) return;
    var showAfter = parseInt(bar.getAttribute('data-show-after') || '700', 10);
    var hideNearEnd = parseInt(bar.getAttribute('data-hide-near-end') || '92', 10);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var y = h.scrollTop || window.pageYOffset;
      var pct = max > 0 ? (y / max * 100) : 0;
      var shouldShow = y > showAfter && pct < hideNearEnd;
      bar.classList.toggle('is-visible', shouldShow);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    on(window, 'resize', update);
    update();
  }

  function init() {
    if (window.__listicleHotel.initialized) return;
    window.__listicleHotel.initialized = true;
    $$(SCOPE).forEach(function (section) {
      initTestimonials(section);
      initStickyBar(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-listicle-hotel')) {
      window.__listicleHotel.initialized = false;
      init();
    }
  });
})();